import styled from 'styled-components'

export const Row = styled.div.attrs({
  className: `intuix-ui-row`
})`
  width: 100%;

  display: flex;
  flex-wrap: wrap;

  box-sizing: border-box;
`
